import React, { useState } from 'react';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import Loader from '../../elements/Loader';

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #f5e6d3 0%, #fdf3e7 40%, #fff8f0 100%)',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  card: {
    background: '#ffffff',
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(196, 112, 60, 0.15), 0 4px 20px rgba(0,0,0,0.08)',
    padding: '48px 44px',
    width: '100%',
    maxWidth: '420px',
    position: 'relative',
    overflow: 'hidden',
  },
  topAccent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: 'linear-gradient(90deg, #C4703C, #e8945a, #C4703C)',
  },
  logoWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '28px',
  },
  logo: {
    height: '52px',
    objectFit: 'contain',
    display: 'block',
  },
  logoFallback: {
    fontSize: '26px',
    fontWeight: '700',
    color: '#C4703C',
    letterSpacing: '-0.5px',
  },
  heading: {
    textAlign: 'center',
    fontSize: '22px',
    fontWeight: '700',
    color: '#1a1a1a',
    marginBottom: '6px',
  },
  subheading: {
    textAlign: 'center',
    fontSize: '14px',
    color: '#888',
    marginBottom: '32px',
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#444',
    marginBottom: '6px',
  },
  inputWrap: {
    position: 'relative',
    marginBottom: '20px',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '14px',
    border: '1.5px solid #e8e0d8',
    borderRadius: '10px',
    outline: 'none',
    background: '#fafaf8',
    color: '#1a1a1a',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s, box-shadow 0.2s',
  },
  inputWithToggle: {
    width: '100%',
    padding: '12px 44px 12px 16px',
    fontSize: '14px',
    border: '1.5px solid #e8e0d8',
    borderRadius: '10px',
    outline: 'none',
    background: '#fafaf8',
    color: '#1a1a1a',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s, box-shadow 0.2s',
  },
  eyeBtn: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#aaa',
    padding: '4px',
    fontSize: '16px',
    lineHeight: 1,
  },
  primaryBtn: {
    width: '100%',
    padding: '13px',
    background: 'linear-gradient(135deg, #C4703C, #d4804c)',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'opacity 0.2s, transform 0.1s',
    marginTop: '4px',
    letterSpacing: '0.3px',
  },
  divider: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    margin: '20px 0',
  },
  dividerLine: {
    flex: 1,
    height: '1px',
    background: '#ece6de',
  },
  dividerText: {
    fontSize: '12px',
    color: '#bbb',
    fontWeight: '500',
  },
  googleBtn: {
    width: '100%',
    padding: '12px',
    background: '#fff',
    color: '#444',
    border: '1.5px solid #e0dbd4',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    transition: 'background 0.2s, border-color 0.2s',
  },
};

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    <path fill="none" d="M0 0h48v48H0z"/>
  </svg>
);

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [logoError, setLogoError] = useState(false);

  const storeAuthAndRedirect = (data) => {
    localStorage.setItem('authToken', JSON.stringify(data.token));
    localStorage.setItem('roleAccess', JSON.stringify(data?.roleAccess));
    window.location.href = '/';
  };

  const handlePasswordLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    ApiService.post('auth/admin-login', { email, password })
      .then((data) => {
        toast.success(data.msg);
        storeAuthAndRedirect(data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.msg || 'Login failed');
        setLoading(false);
      });
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (response) => {
      const profileData = await axios.get('https://www.googleapis.com/oauth2/v1/userinfo', {
        headers: { Authorization: `Bearer ${response.access_token}` },
      });
      if (profileData?.data?.email) {
        setLoading(true);
        ApiService.post('auth/login', { email: profileData.data.email })
          .then((data) => {
            toast.success(data.msg);
            storeAuthAndRedirect(data);
          })
          .catch((err) => {
            toast.error(err?.response?.data?.msg || 'Login failed');
            setLoading(false);
          });
      }
    },
    onError: () => toast.error('Google login failed'),
    scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
  });

  return (
    <>
      {loading && <Loader />}
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.topAccent} />

          <div style={styles.logoWrap}>
            {!logoError ? (
              <img
                src="https://teertham.s3.ap-south-1.amazonaws.com/images/teertham-logo.png"
                alt="Teertham"
                style={styles.logo}
                onError={() => setLogoError(true)}
              />
            ) : (
              <span style={styles.logoFallback}>Teertham</span>
            )}
          </div>

          <h2 style={styles.heading}>Welcome back</h2>
          <p style={styles.subheading}>Sign in to your admin account</p>

          <form onSubmit={handlePasswordLogin}>
            <div>
              <label style={styles.label}>Email address</label>
              <div style={styles.inputWrap}>
                <input
                  type="email"
                  style={styles.input}
                  placeholder="you@teertham.org"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onFocus={(e) => { e.target.style.borderColor = '#C4703C'; e.target.style.boxShadow = '0 0 0 3px rgba(196,112,60,0.12)'; }}
                  onBlur={(e) => { e.target.style.borderColor = '#e8e0d8'; e.target.style.boxShadow = 'none'; }}
                  required
                />
              </div>
            </div>

            <div>
              <label style={styles.label}>Password</label>
              <div style={{ ...styles.inputWrap, position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  style={styles.inputWithToggle}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={(e) => { e.target.style.borderColor = '#C4703C'; e.target.style.boxShadow = '0 0 0 3px rgba(196,112,60,0.12)'; }}
                  onBlur={(e) => { e.target.style.borderColor = '#e8e0d8'; e.target.style.boxShadow = 'none'; }}
                  required
                />
                <button
                  type="button"
                  style={styles.eyeBtn}
                  onClick={() => setShowPassword(v => !v)}
                  tabIndex={-1}
                >
                  {showPassword ? (
                    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/></svg>
                  ) : (
                    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              style={styles.primaryBtn}
              onMouseEnter={(e) => e.target.style.opacity = '0.9'}
              onMouseLeave={(e) => e.target.style.opacity = '1'}
            >
              Sign In
            </button>
          </form>

          <div style={styles.divider}>
            <div style={styles.dividerLine} />
            <span style={styles.dividerText}>or continue with</span>
            <div style={styles.dividerLine} />
          </div>

          <button
            type="button"
            style={styles.googleBtn}
            onClick={() => googleLogin()}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#fafafa'; e.currentTarget.style.borderColor = '#c8c0b8'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e0dbd4'; }}
          >
            <GoogleIcon />
            Sign in with Google
          </button>
        </div>
      </div>
    </>
  );
}
